import React from 'react';
import { getPath } from '../utils/functions';

function FaqAnswer({ faq }) {
  if (!faq.answerParts) {
    return <>{faq.answer}</>;
  }

  return (
    <>
      {faq.answerParts.map((part, index) =>
        part.type === 'link' ? (
          <a
            key={index}
            href={getPath(part.path)}
            target={part.newTab ? '_blank' : undefined}
            rel={part.newTab ? 'noopener noreferrer' : undefined}
          >
            {part.text}
          </a>
        ) : (
          <span key={index}>{part.value}</span>
        )
      )}
    </>
  );
}

export default FaqAnswer;
